import { memo, useId, useState } from 'react';

const MAX_LENGTH = 200;

// Keep expansion local so a click does not rerender the feed, dates, or replies.
const PostBody = memo(function PostBody({ content = '', fileName, author, appRoot }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const contentId = useId();
  const text = content || '';
  const isLong = text.length > MAX_LENGTH;
  const attachmentUrl = fileName ? `${appRoot}/post_file/${encodeURIComponent(fileName)}` : '';
  const isImage = /\.(jpe?g|png|gif)$/i.test(fileName || '');

  return (
    <>
      <p id={contentId} className="whitespace-pre-wrap mb-3">
        {isExpanded || !isLong ? text : `${text.slice(0, MAX_LENGTH)}...`}
      </p>

      {attachmentUrl && (
        <a href={attachmentUrl} target="_blank" rel="noopener noreferrer" className="mb-3 block">
          {isImage ? (
            <img
              src={attachmentUrl}
              alt={`Attachment from ${author}`}
              loading="lazy"
              className="max-h-96 max-w-full rounded-lg object-contain"
            />
          ) : (
            <span className="text-sm font-semibold text-indigo-600 hover:underline">View PDF attachment</span>
          )}
        </a>
      )}

      {isLong && (
        <button
          type="button"
          aria-expanded={isExpanded}
          aria-controls={contentId}
          className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0 w-full"
          onClick={() => setIsExpanded((expanded) => !expanded)}
        >
          {isExpanded ? 'Show less' : 'View all'}
        </button>
      )}
    </>
  );
});

export default PostBody;
